import './components/intro-return.js';
import './components/navbar.js';
import './components/sante-prev-scrollmagic.js';
import './components/scrollto.js';
import './components/typeform-block.js';

$('.menu-navbar__top-level__link[data-page="sante-prev"]').addClass('is-active');